import { Component, Input, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-catalogue-template',
  templateUrl: './catalogue-template.component.html',
  styleUrls: ['./catalogue-template.component.scss']
})
export class CatalogueTemplateComponent implements OnInit {
  @Input() title: string = "Brand";
  @Input() info: string = "Info";
  @Input() productList = [];
  @Input() expand: Function;
  @Input() moveProduct: Function;

  @Input() headerTitle!: string;
  @Input() isCurated = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  toggleExpand(product: any, event: MouseEvent) {
    event.stopPropagation();   // 👈 prevents row click
    this.expand(product.productId);
    product.isExpanded = !product.isExpanded;
  }

  move(pId: string, vId?: string) {
    //console.log({pId, vId});
    this.moveProduct(pId, vId);
  }
}